<template>
  <div class="relative h-full w-12">
    <div class="flex flex-column align-items-center absolute-center gap-4">
      <h1 class="text-center">Coming soon..</h1>
  
      <p class="flex align-items-center gap-5">
        <span>powered by</span> 
        <img :src="`${config.cdnURL}images/logo_sf.png`" width="200" />
      </p>
    </div>
  </div>
</template>
<script setup lang="ts">
  definePageMeta({
    layout: 'base',
    title: 'Home - powerflow',
  });

  const { public: config } = useRuntimeConfig();
</script>
